// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u01b66{margin-left:var(--ds-space-050,4px)}\n._18u0mgjw{margin-left:var(--ds-space-negative-200,-1pc)}\n._19pku2gc{margin-top:var(--ds-space-100,8px)}\n._vwz41ejb{line-height:var(--ds-space-300,24px)}\n._xhc01b66 >:not(:first-of-type){margin-top:var(--ds-space-050,4px)}", ""]);
// Exports
module.exports = exports;
